<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <span *ngIf="invoiceId > 0">
        <mat-icon>edit</mat-icon> Edit Invoice <span>OHA Id: {{invoiceId}}</span>
      </span>
      <span *ngIf="invoiceId == 0">
        <mat-icon>add</mat-icon> Add Invoice
      </span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">&nbsp;</div>
</div>

<div *ngIf="!loading">
  <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
    <mat-tab label="Invoice Information">
      <br />
      <form [formGroup]="invoiceForm" class="form-field-full">
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Invoice Number" formControlName="invoiceNumber">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Organization Name</mat-label>
                    <input type="text" placeholder="Search Organization Name" aria-label="Organization Name" matInput [formControl]="labsControl" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let option of filteredLabs | async" [value]="option.labName">
                        {{option.labName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Voucher Identifier</mat-label>
                    <input type="text" placeholder="Search Voucher Id" aria-label="Voucher Id" matInput [formControl]="voucherIdsControl" [matAutocomplete]="auto2">
                    <mat-autocomplete #auto2="matAutocomplete" (optionSelected)='voucherIdentifierChange($event.option.value)'>
                      <mat-option *ngFor="let option of filteredVoucherIds | async" [value]="option.value">
                        {{option.text}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>

        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Invoice Type</mat-label>
                    <mat-select id="invoiceType" name="invoiceType" formControlName="invoiceType">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of invoiceService.invoiceTypes" value="{{item}}">{{item}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="66.33" fxFlex.lt-sm="100" *ngIf="invoice?.treatmentId != null && invoice?.treatmentId > 0">
                  &nbsp;&nbsp;

                  <button mat-button (click)="editTreatment()" title="Edit Treatment">
                    <b>Treatment Id: {{invoice.treatmentId}}</b></button>


                </div>
              </div>
            </mat-card>
          </div>
        </div>

        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Approved DWSP Coord</mat-label>
                    <input id="approvedByCoordinator" name="approvedByCoordinator" formControlName="approvedByCoordinator" placeholder="mm/dd/yyyy" matInput [matDatepicker]="approvedByCoordinator" />
                    <mat-datepicker-toggle matSuffix [for]="approvedByCoordinator"></mat-datepicker-toggle>
                    <mat-datepicker #approvedByCoordinator>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Sample Date</mat-label>
                    <input id="sampleDate" name="sampleDate" formControlName="sampleDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="sampleDate" matTooltipClass="tooltip"
                      matTooltip="The most Nitrate test date from the Associated Well of the Voucher (using the Voucher Identifier)" />
                    <mat-datepicker-toggle matSuffix [for]="sampleDate"></mat-datepicker-toggle>
                    <mat-datepicker #sampleDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Service Date</mat-label>
                    <input id="serviceDate" name="serviceDate" formControlName="serviceDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="serviceDate" matTooltipClass="tooltip"
                      matTooltip="Fill in from the most recent Sample Date" />
                    <mat-datepicker-toggle matSuffix [for]="serviceDate"></mat-datepicker-toggle>
                    <mat-datepicker #serviceDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Approved By Manager</mat-label>
                    <input id="approvedByManager" name="approvedByManager" formControlName="approvedByManager" placeholder="mm/dd/yyyy" matInput [matDatepicker]="approvedByManager" />
                    <mat-datepicker-toggle matSuffix [for]="approvedByManager"></mat-datepicker-toggle>
                    <mat-datepicker #approvedByManager>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Sent to Fiscal</mat-label>
                    <input id="sentToFiscal" name="sentToFiscal" formControlName="sentToFiscal" placeholder="mm/dd/yyyy" matInput [matDatepicker]="sentToFiscal" />
                    <mat-datepicker-toggle matSuffix [for]="sentToFiscal"></mat-datepicker-toggle>
                    <mat-datepicker #sentToFiscal>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Received Date</mat-label>
                    <input id="receivedDate" name="receivedDate" formControlName="receivedDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="receivedDate" />
                    <mat-datepicker-toggle matSuffix [for]="receivedDate"></mat-datepicker-toggle>
                    <mat-datepicker #receivedDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Due Date</mat-label>
                    <input id="dueDate" name="dueDate" formControlName="dueDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="dueDate" />
                    <mat-datepicker-toggle matSuffix [for]="dueDate"></mat-datepicker-toggle>
                    <mat-datepicker #dueDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>Paid Date</mat-label>
                    <input id="paidDate" name="paidDate" formControlName="paidDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="paidDate" />
                    <mat-datepicker-toggle matSuffix [for]="paidDate"></mat-datepicker-toggle>
                    <mat-datepicker #paidDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="EDD Received" formControlName="amountPaid">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Invoice Amount" formControlName="amountDue">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100" fxLayoutAlign="center center">
                  <mat-checkbox formControlName="paymentComplete">
                    <small>Is the Payment Complete?</small>
                  </mat-checkbox>
                </div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input formControlName="index" placeholder="Index" matInput matTooltipClass="tooltip" matTooltip="For GWMA - Index: 50207" />
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input formControlName="pca" placeholder="PCA" matInput matTooltipClass="tooltip" matTooltip="For GWMA - PCA: 51050" />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input formControlName="agencyObjectCode" placeholder="Agency Object Code" matInput matTooltipClass="tooltip" matTooltip="For GWMA - Agency Object Code: 4555" />
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input formControlName="mailCode" placeholder="Mail Code" matInput matTooltipClass="tooltip" matTooltip="For GWMA - Mail Code: 0000" />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field fxFlex="100">
                    <textarea matInput placeholder="Service Description" formControlName="comments" rows="5"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <button mat-raised-button [disabled]="processing || loading || authService.isReadOnly()" color="primary" (click)="onSubmit()" title="{{buttonText}}">{{buttonText}}</button>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <small *ngIf="invoiceId > 0">Last Updated on {{invoice?.lastUpdated}} by {{invoice?.lastUpdatedBy}}</small>
          </div>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
</div>